import React from "react";
import PropTypes from  "prop-types";
import ReactInterval from "react-interval";
import "moment/locale/ru";
import Moment from "react-moment";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
// import material-ui icons
import DeleteIcon from "@material-ui/icons/Delete";
import CheckIcon from "@material-ui/icons/CheckCircle";
import ClockIcon from "@material-ui/icons/Schedule";
import PersonIcon from "@material-ui/icons/AccountCircle";
import WaterIcon from "@material-ui/icons/LocalDrink";
import BuildIcon from "@material-ui/icons/Build";
import AlarmIcon from "@material-ui/icons/Alarm";
import NextIcon from "@material-ui/icons/NavigateNext";
import NotificationIcon from "@material-ui/icons/NotificationsActive"
import WarningIcon from "@material-ui/icons/Warning";
import UploadIcon from "@material-ui/icons/Publish";
// import material-ui components
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/styles";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import CircularProgress from "@material-ui/core/CircularProgress";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as actionCreators from "actions/reports";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem";
import CustomInput from "components/CustomInput/CustomInput";
import MutedText from "components/Typography/Muted";
import DeleteDialog from "components/Dialogs/ConfirmDeleteDialog";
import ReportImageUploadDialog from "components/Dialogs/ReportImageUploadDialog";

import reportStyle from "assets/jss/material-dashboard-react/views/reportStyle";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        report: state.reports.report,
        works: state.reports.works,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class ReportView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reportData: null,
            reportId: this.props.match.params.id ? this.props.match.params.id : null,
            timeoutEnabled: false,
            reportDescription: null,
            reportWorks: [],
            reportImages: [],
            deleteReportDialogIsOpened: false,
            reportImageUploadDialogIsOpened: false,
        }
    }

    componentWillReceiveProps(nextProps, nextContext){
        this.setState(prevState => ({
            ...prevState,
            reportId: nextProps.match.params.id ? nextProps.match.params.id : null,
            reportData: nextProps.report.isLoaded ? nextProps.report.data : prevState.reportData,
            reportDescription: nextProps.report.isLoaded && prevState.reportDescription === null
                ? nextProps.report.data.description : prevState.reportDescription,
            reportWorks: nextProps.report.isLoaded && this.props.report.isLoading
                ? nextProps.report.data.works_id : prevState.reportWorks,
            reportImages: nextProps.report.isLoaded && !!nextProps.report.data.images.length
                ? nextProps.report.data.images.map(image => ({
                original: window.location.origin + image.file_url,
                thumbnail: window.location.origin + image.thumb_url,
            })) : prevState.reportImages,
        }));
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true,
        });
        this.getData();
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
            reportData: null,
            reportId: null,
            reportDescription: null,
            reportWorks: [],
            reportImages: [],
            reportImageUploadDialogIsOpened: false,
        },() => console.log(this.state))
    }

    getData(){
        this.props.getReport(this.props.token, this.state.reportId);
        this.props.getReportsWorks(this.props.token);
    }

    handleChangeState(type, data){
        this.setState({
            [type]: data
        })
    }

    saveReport() {
        this.props.editReport(this.props.token, {
            id: this.state.reportId,
            description: this.state.reportDescription,
            works_id: this.state.reportWorks,
        })
    }

    deleteReportDialogOpen(){
        this.setState({
            deleteReportDialogIsOpened: true,
        })
    }

    deleteReportDialogClose(){
        this.setState({
            deleteReportDialogIsOpened: false
        })
    }

    deleteReport(){
        this.deleteReportDialogClose();
        this.props.deleteReport(this.props.token, this.state.reportId);
    }

    reportImageUploadDialogOpen(){
        this.setState({
            reportImageUploadDialogIsOpened: true,
        })
    }

    reportImageUploadDialogClose(){
        this.setState({
            reportImageUploadDialogIsOpened: false,
        });
        this.getData();
    }

    render(){
        const { classes } = this.props;
        return this.props.report.isLoaded && this.state.reportData ? <Grid container>
                <GridItem xs={12} md={10}>
                    <div className={classes.flex_left}>
                        <div className={classes.report_id}><MutedText>{`#${this.state.reportData.id}`}</MutedText></div>
                        <h4><b>{this.state.reportData.name}</b></h4>
                    </div>
                    <div className={classes.flex_left}>
                        <div className={classes.text_with_icon_block}>
                            <ClockIcon/>
                            <Moment className={classes.text_with_icon} format="DD/MM/YYYY HH:mm">{this.state.reportData.creation_time}</Moment>
                        </div>
                        {this.state.reportData.created_by_type === 0 &&
                            <div className={classes.text_with_icon_block}>
                                <PersonIcon/>
                                <span className={classes.text_with_icon}>{this.state.reportData.created_by_user_name}</span>
                            </div>
                        }
                        {this.state.reportData.created_by_type === 1 &&
                            <div className={classes.text_with_icon_block}>
                                <BuildIcon/>
                                <span className={classes.text_with_icon}>Автоматически</span>
                            </div>
                        }
                        {this.state.reportData.created_by_type === 2 &&
                            <div className={classes.text_with_icon_block}>
                                <AlarmIcon/>
                                <span className={classes.text_with_icon}>По расписанию</span>
                            </div>
                        }
                        <div className={classes.text_with_icon_block}>
                            <WaterIcon/>
                            <span className={classes.text_with_icon}>{this.state.reportData.machine_address}</span>
                        </div>
                        <div className={classes.text_with_icon_block}>
                            {this.state.reportData.created_by_type === 2 ? <NotificationIcon/> : <WarningIcon/>}
                            <span className={classes.text_with_icon}>{this.state.reportData.subject}</span>
                        </div>
                    </div>
                </GridItem>
                <GridItem xs={12} md={2}>
                    <div className={classes.btnContainer}>
                        <Button color="danger" onClick={() => this.deleteReportDialogOpen()}>
                            <DeleteIcon/>
                            Удалить
                        </Button>
                    </div>
                </GridItem>
                <GridItem xs={12} md={8}>
                    <Stepper activeStep={-1} classes={{root: classes.stepperPaper}}
                             orientation={window.innerWidth <= 760 ? "vertical" : "horizontal"}>
                        <Step completed={this.state.reportData.status_id > 0}>
                            <StepLabel icon={<CheckIcon/>}
                                       className={this.state.reportData.status_id > 0 ? classes.stepperIconActive : classes.stepperIconInactive}
                                       optional={this.state.reportData.status_id > 0 ? <MutedText>
                                           <Moment from={this.state.reportData.creation_time}>{this.state.reportData.acceptance_time}</Moment>
                                       </MutedText> : null}>
                                Принята
                            </StepLabel>
                        </Step>
                        <Step completed={this.state.reportData.status_id > 1}>
                            <StepLabel icon={<CheckIcon/>}
                                       className={this.state.reportData.status_id > 1 ? classes.stepperIconActive : classes.stepperIconInactive}
                                       optional={this.state.reportData.status_id > 1 ? <MutedText>
                                           <Moment from={this.state.reportData.acceptance_time}>{this.state.reportData.departure_time}</Moment>
                                       </MutedText> : null}>
                                Выезд
                            </StepLabel>
                        </Step>
                        <Step completed={this.state.reportData.status_id > 2}>
                            <StepLabel icon={<CheckIcon/>}
                                       className={this.state.reportData.status_id > 2 ? classes.stepperIconActive : classes.stepperIconInactive}
                                       optional={this.state.reportData.status_id > 2 ? <MutedText>
                                           <Moment from={this.state.reportData.departure_time}>{this.state.reportData.arrival_time}</Moment>
                                       </MutedText> : null}>
                                В работе
                            </StepLabel>
                        </Step>
                        <Step completed={this.state.reportData.status_id > 3}>
                            <StepLabel icon={<CheckIcon/>}
                                       className={this.state.reportData.status_id > 3 ? classes.stepperIconActive : classes.stepperIconInactive}
                                       optional={this.state.reportData.status_id > 3 ? <MutedText>
                                           <Moment from={this.state.reportData.arrival_time}>{this.state.reportData.completion_time}</Moment>
                                       </MutedText> : null}>
                                Завершена
                            </StepLabel>
                        </Step>
                    </Stepper>
                </GridItem>
                <GridItem xs={0} md={2}/>
                <GridItem xs={12} md={2}>
                    <div className={classes.btnContainer1}>
                        <Button color="success" onClick={() => this.props.getReportNext(this.props.token, this.state.reportId)}
                                disabled={this.state.reportData.status_id === 4 || this.state.reportData.status_id === 0}>
                            <NextIcon/>
                            &nbsp;&nbsp;&nbsp;Далее&nbsp;&nbsp;&nbsp;
                        </Button>
                    </div>
                </GridItem>
                <GridItem xs={12} md={6}>
                    <FormControl fullWidth disabled={this.props.report.data.status_id === 4}>
                        <InputLabel htmlFor="select-report-works">Выполненные работы</InputLabel>
                        <Select
                            multiple
                            value={this.state.reportWorks}
                            onChange={e => this.handleChangeState("reportWorks",e.target.value)}
                            input={<Input id="select-report-works" fullWidth/>}
                            renderValue={selected => (
                                <div>
                                    {selected.map(value => (
                                        <Chip key={value} label={this.props.works.isLoaded
                                            ? this.props.works.data.filter(work => work.id === value ? work.name : null)[0].name : "..."}/>
                                    ))}
                                </div>
                            )}
                        >
                            {this.props.works.data.map(work => (
                                <MenuItem
                                    key={work.id}
                                    value={work.id}
                                    style={{
                                        fontWeight:
                                            this.state.reportWorks.indexOf(work.id) === -1
                                                ? this.props.theme.typography.fontWeightRegular
                                                : this.props.theme.typography.fontWeightMedium,
                                    }}
                                >
                                    {work.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <CustomInput labelText="Описание"
                                 formControlProps={{
                                     fullWidth: true
                                 }}
                                 inputProps={{
                                     value: this.state.reportDescription,
                                     onChange: e => this.handleChangeState("reportDescription", e.target.value),
                                     multiline: true,
                                     rows: "3",
                                 }}/>
                    <div className={classes.flex_right}>
                        <Button color="primary" onClick={() => this.saveReport()}>Сохранить</Button>
                    </div>
                </GridItem>
                <GridItem md={6}/>
                <GridItem md={2}/>
                <GridItem xs={12} md={8}>
                    <div className={classes.galleryContainer}>
                        {!!this.state.reportImages.length && <ImageGallery items={this.state.reportImages}/>}
                    </div>
                </GridItem>
                <GridItem xs={12}>
                    <div className={classes.flex_around}>
                        <Button color="success" onClick={() => this.reportImageUploadDialogOpen()}>
                            <UploadIcon/>Загрузить изображение
                        </Button>
                    </div>
                </GridItem>
                <DeleteDialog isOpened={this.state.deleteReportDialogIsOpened}
                              onCancel={() => this.deleteReportDialogClose()} onSave={() => this.deleteReport()}
                              bodyText="Вы действительно хотите удалить эту заявку? Это действие нельзя будет отменить."
                              headerText="Удалить заявку"/>
                <ReportImageUploadDialog isOpened={this.state.reportImageUploadDialogIsOpened}
                                         onCancel={() => this.reportImageUploadDialogClose()}
                                         maxFiles={this.props.report.isLoaded && 10 - this.props.report.data.images.length}
                                         token={this.props.token} report_id={this.state.reportData.id}/>
                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </Grid>:
            <div className={classes.curricular_progress_container}>
                <CircularProgress size={55}/>
                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
    }
}

ReportView.propTypes = {
    getReport: PropTypes.func,
    getReportNext: PropTypes.func,
    editReport: PropTypes.func,
    deleteReport: PropTypes.func,
    getReportsWorks: PropTypes.func,
    token: PropTypes.string,
    report: PropTypes.object,
    works: PropTypes.arrayOf(PropTypes.object)
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(reportStyle, { withTheme: true })(ReportView));


// WEBPACK FOOTER //
// ./src/views/Reports/Report.jsx